import classNames from "classnames";

import type {ISearchComboboxSkeletonProps} from "../types/ISearchComboboxSkeletonProps";

import * as styles from "./SearchComboboxSkeleton.module.css";

// Bar widths, cycled: rows 1-4 use variants 0-3.
const VARIANT_COUNT = 4;

/** Loading placeholder. Hidden from assistive technology - "Szukamy…" goes through the live region. */
export const SearchComboboxSkeleton = (props: ISearchComboboxSkeletonProps) => {
    const {title = "Szukamy…", rows = 4, className, dataTestId} = props;
    const rowIndexes = Array.from({length: Math.max(0, rows)}, (_, index) => index);

    return (
        <div className={classNames(styles.skeleton, className)} data-testid={dataTestId} aria-hidden="true">
            <div className={styles.header}>{title}</div>
            {rowIndexes.map((index) => (
                <div key={index} className={classNames(styles.row, styles[`rowVariant${index % VARIANT_COUNT}`])}>
                    <span className={styles.tile} />
                    <span className={styles.lines}>
                        <span className={classNames(styles.bar, styles.titleBar)} />
                        <span className={classNames(styles.bar, styles.subtitleBar)} />
                    </span>
                    <span className={classNames(styles.bar, styles.metaBar)} />
                </div>
            ))}
        </div>
    );
};
import classNames from "classnames";

import type {ISearchComboboxSkeletonProps} from "../types/ISearchComboboxSkeletonProps";

import * as styles from "./SearchComboboxSkeleton.module.css";

// Bar widths, cycled: rows 1-4 use variants 0-3.
const VARIANT_COUNT = 4;

/** Loading placeholder. Hidden from assistive technology - "Szukamy…" goes through the live region. */
export const SearchComboboxSkeleton = (props: ISearchComboboxSkeletonProps) => {
    const {title = "Szukamy…", rows = 4, className, dataTestId} = props;
    const rowIndexes = Array.from({length: Math.max(0, rows)}, (_, index) => index);

    return (
        <div className={classNames(styles.skeleton, className)} data-testid={dataTestId} aria-hidden="true">
            <div className={styles.header}>{title}</div>
            {rowIndexes.map((index) => (
                <div key={index} className={classNames(styles.row, styles[`rowVariant${index % VARIANT_COUNT}`])}>
                    <span className={styles.tile} />
                    <span className={styles.lines}>
                        <span className={classNames(styles.bar, styles.titleBar)} />
                        <span className={classNames(styles.bar, styles.subtitleBar)} />
                    </span>
                    <span className={classNames(styles.bar, styles.metaBar)} />
                </div>
            ))}
        </div>
    );
};
